/* eslint-disable max-len */
import { ProductAttributeKey, ProductDimensionAttributeKey } from '../../entities/@api/Sylius';
import { Product } from '../../entities/@products/Product/Product';
import { ProductVariantColor } from '../../entities/@products/ProductVariantColor/ProductVariantColor';
import { MOCK_BRANDS } from './brand';
import {
    MOCK_PRODUCT_IMAGE_1,
    MOCK_PRODUCT_IMAGE_2,
    MOCK_PRODUCT_IMAGE_3,
    MOCK_PRODUCT_IMAGE_4,
    MOCK_PRODUCT_IMAGE_5,
    MOCK_PRODUCT_IMAGE_6,
    MOCK_PRODUCT_IMAGE_7,
    MOCK_VIDEO,
} from './media';

export const MOCK_PRODUCT_1: Product = {
    id: '1',
    legacyId: '1',
    stockQuantity: 1,
    slug: 'bijzettafel-mala-glossy',
    name: 'Bijzettafel Mala glossy',
    brand: {
        label: MOCK_BRANDS[0].name,
        href: MOCK_BRANDS[0].slug,
    },
    mediaItems: [
        { id: '1', image: MOCK_PRODUCT_IMAGE_1 },
        { id: '2', image: MOCK_PRODUCT_IMAGE_2 },
        { id: '3', image: MOCK_PRODUCT_IMAGE_3 },
        { id: '4', video: MOCK_VIDEO },
        { id: '5', image: MOCK_PRODUCT_IMAGE_5 },
        { id: '6', image: MOCK_PRODUCT_IMAGE_6 },
    ],
    price: {
        original: 2500,
        current: 5000,
    },
    description: `
        <p>Deze tafellamp wordt gemaakt door DE Italiaanse fabrikant op dit gebied: Zafferano.</p>
        <p>De lamp kan zowel binnen als buiten worden toegepast en is zo een sfeermaker in huis, maar ook in de tuin, op de camping, op het balkon en in de boot. Door de handige dimfunctie creëer je altijd de sfeer die past bij het moment.</p>
        <p>Je kan de tafellamp Ofelia micro ook in Loods5 Amersfoort bekijken. Hier vind je de kleuren zachtgroen, donkergrijs. Online is de tafellamp Ofelia micro ook verkrijgbaar in de kleuren wit, zand en corten (roest).</p>    
    `,
    attributes: [
        { key: ProductAttributeKey.materials, label: 'Lichtbron', value: '2,2 Watt LED CRI &gt; 80 (inbegrepen)' },
        { key: ProductAttributeKey.materials, label: 'Lichtkleur', value: '2200-2700-3000 K (warm wit)' },
        { key: ProductAttributeKey.materials, label: 'Dimbaar', value: 'Ja, door middel van touch' },
        { key: ProductAttributeKey.materials, label: 'Batterij', value: '9 uur op vol vermogen en minimaal 12 uur gedimd' },
        { key: ProductAttributeKey.materials, label: 'Oplaadtijd', value: '4,5 uur' },
        { key: ProductAttributeKey.materials, label: 'Oplaadstation', value: 'inbegrepen' },
        { key: ProductAttributeKey.materials, label: 'Oplaadbaar', value: 'IP 65 waterdicht' },
    ],
    dimensionAttributes: [
        { key: ProductDimensionAttributeKey.width, label: 'Breedte', value: 'Niet beschikbaar' },
        { key: ProductDimensionAttributeKey.height, label: 'Hoogte', value: 'Niet beschikbaar' },
        { key: ProductDimensionAttributeKey.radius, label: 'Diameter', value: 'Niet beschikbaar' },
    ],
    colors: [],
    variantsCount: 2,
    inStock: false,
    isNew: false,
    variantId: '',
    relativeUrl: '',
    productCode: '',
    variantCode: '',
};

export const MOCK_PRODUCT_2: Product = {
    id: '2',
    stockQuantity: 1,
    legacyId: '2',
    slug: 'kussen-maysa',
    name: 'Kussen Maysa',
    brand: {
        label: MOCK_BRANDS[1].name,
        href: MOCK_BRANDS[1].slug,
    },
    mediaItems: [
        { id: '2', image: MOCK_PRODUCT_IMAGE_2 },
    ],
    colors: [
        ProductVariantColor.red,
        ProductVariantColor.green,
        ProductVariantColor.gold,
        ProductVariantColor.silver,
        ProductVariantColor.beige,
        ProductVariantColor.brown,
    ],
    price: {
        original: 2500,
        current: 5000,
    },
    description: `
        <p>Deze tafellamp wordt gemaakt door DE Italiaanse fabrikant op dit gebied: Zafferano.</p>
        <p>De lamp kan zowel binnen als buiten worden toegepast en is zo een sfeermaker in huis, maar ook in de tuin, op de camping, op het balkon en in de boot. Door de handige dimfunctie creëer je altijd de sfeer die past bij het moment.</p>
        <p>Je kan de tafellamp Ofelia micro ook in Loods5 Amersfoort bekijken. Hier vind je de kleuren zachtgroen, donkergrijs. Online is de tafellamp Ofelia micro ook verkrijgbaar in de kleuren wit, zand en corten (roest).</p>    
    `,
    attributes: [],
    dimensionAttributes: [],
    variantsCount: 1,
    inStock: true,
    isNew: true,
    variantId: '',
    relativeUrl: '',
    productCode: '',
    variantCode: '',
};

export const MOCK_PRODUCT_3: Product = {
    id: '3',
    legacyId: '3',
    stockQuantity: 1,
    slug: 'salontafel-lilla',
    name: 'Salontafel Lilla',
    brand: {
        label: MOCK_BRANDS[2].name,
        href: MOCK_BRANDS[2].slug,
    },
    mediaItems: [
        { id: '3', image: MOCK_PRODUCT_IMAGE_3 },
    ],
    colors: [],
    price: {
        original: 2500,
        current: 5000,
    },
    description: `
        <p>Deze tafellamp wordt gemaakt door DE Italiaanse fabrikant op dit gebied: Zafferano.</p>
        <p>De lamp kan zowel binnen als buiten worden toegepast en is zo een sfeermaker in huis, maar ook in de tuin, op de camping, op het balkon en in de boot. Door de handige dimfunctie creëer je altijd de sfeer die past bij het moment.</p>
        <p>Je kan de tafellamp Ofelia micro ook in Loods5 Amersfoort bekijken. Hier vind je de kleuren zachtgroen, donkergrijs. Online is de tafellamp Ofelia micro ook verkrijgbaar in de kleuren wit, zand en corten (roest).</p>    
    `,
    attributes: [],
    dimensionAttributes: [],
    variantsCount: 1,
    inStock: true,
    isNew: false,
    variantId: '',
    relativeUrl: '',
    productCode: '',
    variantCode: '',
};

export const MOCK_PRODUCT_4: Product = {
    id: '4',
    legacyId: '4',
    stockQuantity: 1,
    slug: 'vaas-loa-12x26x31cm',
    name: 'Vaas Loa 12x26x31cm',
    brand: {
        label: MOCK_BRANDS[3].name,
        href: MOCK_BRANDS[3].slug,
    },
    mediaItems: [
        { id: '4', image: MOCK_PRODUCT_IMAGE_4 },
    ],
    colors: [],
    price: {
        original: 2500,
        current: 5000,
    },
    description: `
        <p>Deze tafellamp wordt gemaakt door DE Italiaanse fabrikant op dit gebied: Zafferano.</p>
        <p>De lamp kan zowel binnen als buiten worden toegepast en is zo een sfeermaker in huis, maar ook in de tuin, op de camping, op het balkon en in de boot. Door de handige dimfunctie creëer je altijd de sfeer die past bij het moment.</p>
        <p>Je kan de tafellamp Ofelia micro ook in Loods5 Amersfoort bekijken. Hier vind je de kleuren zachtgroen, donkergrijs. Online is de tafellamp Ofelia micro ook verkrijgbaar in de kleuren wit, zand en corten (roest).</p>    
    `,
    attributes: [],
    dimensionAttributes: [],
    variantsCount: 1,
    inStock: true,
    isNew: false,
    variantId: '',
    relativeUrl: '',
    productCode: '',
    variantCode: '',
};

export const MOCK_PRODUCT_5: Product = {
    id: '5',
    legacyId: '5',
    stockQuantity: 1,
    slug: 'bijzettafel-naomi',
    name: 'Bijzettafel Naomi',
    brand: {
        label: MOCK_BRANDS[4].name,
        href: MOCK_BRANDS[4].slug,
    },
    mediaItems: [
        { id: '5', image: MOCK_PRODUCT_IMAGE_5 },
    ],
    colors: [],
    price: {
        original: 2500,
        current: 5000,
    },
    description: `
        <p>Deze tafellamp wordt gemaakt door DE Italiaanse fabrikant op dit gebied: Zafferano.</p>
        <p>De lamp kan zowel binnen als buiten worden toegepast en is zo een sfeermaker in huis, maar ook in de tuin, op de camping, op het balkon en in de boot. Door de handige dimfunctie creëer je altijd de sfeer die past bij het moment.</p>
        <p>Je kan de tafellamp Ofelia micro ook in Loods5 Amersfoort bekijken. Hier vind je de kleuren zachtgroen, donkergrijs. Online is de tafellamp Ofelia micro ook verkrijgbaar in de kleuren wit, zand en corten (roest).</p>    
    `,
    attributes: [],
    dimensionAttributes: [],
    variantsCount: 2,
    inStock: true,
    isNew: false,
    variantId: '',
    relativeUrl: '',
    productCode: '',
    variantCode: '',
};

export const MOCK_PRODUCT_6: Product = {
    id: '6',
    legacyId: '6',
    stockQuantity: 1,
    slug: 'poef-ollie',
    name: 'Poef Ollie',
    brand: {
        label: MOCK_BRANDS[0].name,
        href: MOCK_BRANDS[0].slug,
    },
    mediaItems: [
        { id: '6', image: MOCK_PRODUCT_IMAGE_6 },
    ],

    colors: [],
    price: {
        original: 2500,
        current: 5000,
    },
    description: `
        <p>Deze tafellamp wordt gemaakt door DE Italiaanse fabrikant op dit gebied: Zafferano.</p>
        <p>De lamp kan zowel binnen als buiten worden toegepast en is zo een sfeermaker in huis, maar ook in de tuin, op de camping, op het balkon en in de boot. Door de handige dimfunctie creëer je altijd de sfeer die past bij het moment.</p>
        <p>Je kan de tafellamp Ofelia micro ook in Loods5 Amersfoort bekijken. Hier vind je de kleuren zachtgroen, donkergrijs. Online is de tafellamp Ofelia micro ook verkrijgbaar in de kleuren wit, zand en corten (roest).</p>    
    `,
    attributes: [],
    dimensionAttributes: [],
    variantsCount: 1,
    inStock: true,
    isNew: true,
    variantId: '',
    relativeUrl: '',
    productCode: '',
    variantCode: '',
};

export const MOCK_PRODUCT_7: Product = {
    id: '7',
    legacyId: '7',
    stockQuantity: 1,
    slug: '3-zitsbank-stand-alon-fat-joe-royal',
    name: '3-zitsbank stand alon Fat Joe royal',
    brand: {
        label: MOCK_BRANDS[1].name,
        href: MOCK_BRANDS[1].slug,
    },
    mediaItems: [
        { id: '7', image: MOCK_PRODUCT_IMAGE_7 },
    ],
    colors: [],
    price: {
        original: 2500,
        current: 5000,
    },
    description: `
        <p>Deze tafellamp wordt gemaakt door DE Italiaanse fabrikant op dit gebied: Zafferano.</p>
        <p>De lamp kan zowel binnen als buiten worden toegepast en is zo een sfeermaker in huis, maar ook in de tuin, op de camping, op het balkon en in de boot. Door de handige dimfunctie creëer je altijd de sfeer die past bij het moment.</p>
        <p>Je kan de tafellamp Ofelia micro ook in Loods5 Amersfoort bekijken. Hier vind je de kleuren zachtgroen, donkergrijs. Online is de tafellamp Ofelia micro ook verkrijgbaar in de kleuren wit, zand en corten (roest).</p>    
    `,
    attributes: [],
    dimensionAttributes: [],
    variantsCount: 1,
    inStock: true,
    isNew: false,
    variantId: '',
    relativeUrl: '',
    productCode: '',
    variantCode: '',
};

export const MOCK_PRODUCTS: Product[] = [
    MOCK_PRODUCT_1,
    MOCK_PRODUCT_2,
    MOCK_PRODUCT_3,
];
